<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Usuário</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
             <b-form>
             <b-row>
              <b-col cols="4">
                <b-form-group label="CPF:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-mask="'###.###.###-##'"
                                  id="cpf"
                                  type="text"
                                  :disabled="true"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="usuario.cpf"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Data de Nascimento:">
                  <b-input-group>
                    <div class="input-group-prepend">
                             <span class="input-group-text">
                               <i class='fa fa-calendar'></i>
                             </span>
                    </div>
                    <b-form-input id="type-date"
                                  type="date"
                                  :disabled="true"
                                  v-model="usuario.data_nascimento"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Solicitação:">
                  <b-input-group class="mb-6">
                    <b-form-input type="text"
                                  :disabled="true"
                                  class="form-control"
                                  v-model="usuario.situacao_formatada"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="12">
                <b-form-group label="Nome:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model="usuario.nome"
                                  :disabled="true"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="4">
                <b-form-group label="DDD + Telefone">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  v-mask="'+55 (##) #####-####'"
                                  class="form-control"
                                  placeholder="Telefone"
                                  autocomplete="telefone"
                                  v-model="usuario.telefone"
                                  :disabled="true"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-group label="UF:">
                  <b-form-select v-model="usuario.estado_id" placeholder="Password" :options="estados"
                                 class="mb-3" :disabled="true">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Município:">
                  <b-form-select placeholder="Password"
                                 :options="cidades"
                                 class="mb-3"
                                 v-model="usuario.cidade_id"
                                 :disabled="true">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="12">
                <b-form-group label="E-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  v-model="usuario.email"
                                  :disabled="true"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
              <b-col cols="12">
                <b-form-group v-if="usuario.perfil_temporario !== null" label="Tipo de Usuário:">
                  <b-form-select :disabled="true" v-model="usuario.perfil_temporario" placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                </b-form-group>
                <b-form-group v-else label="Tipo de Usuário:">
                  <b-form-select :disabled="true" v-model="usuario.perfil_id" placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
            <b-button v-if="can('user.update')" variant="primary" @click="navigate"><i class="fa fa-pencil-square-o"></i> Editar</b-button>
             <b-button v-if="usuario.perfil_id > '2' && can('user.ativar') && !usuario.ativo" variant="primary" @click="modalConfirmaAtivacao"><i class="fa fa-toggle-off"></i> Ativar</b-button>
            <b-button v-if="usuario.perfil_id > '2' && can('user.suspender') && usuario.ativo" variant="primary" @click="modalConfirmaSuspensao"><i class="fa fa-toggle-on"></i> Suspender</b-button>
            <b-button v-if="usuario.perfil_id !== 2 && can('user.excluir')" @click="modalConfirmaExclusaoRejeicao('excluir')" variant="primary"><i class="fa fa-times"></i> Excluir</b-button>
            <b-button v-if="usuario.situacao !== '1' && usuario.situacao !== '2' && can('user.rejeitar')" @click="modalConfirmaExclusaoRejeicao('rejeitar')" variant="primary"><i class="fa fa-ban"></i> Rejeitar</b-button>
            <b-button variant="secondary" @click="$router.go(-1)"><i class="fa fa-mail-reply-all"></i> Voltar</b-button>
            <b-button v-if="usuario.situacao !== '1' && usuario.situacao !== '2' && can('user.aprovar')"  @click="modalConfirmaAprovacao" variant="primary"><i class="fa fa-check"></i> Aprovar</b-button>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'

miniToastr.init()
export default {
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarTipoUsuarios')
    this.$store.dispatch('buscarCidades')
    this.$store.dispatch('getUsuario', this.$route.params.id)
  },
  data () {
    return {
      titulo_confirmacao: ''
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidades
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    modalConfirmaExclusaoRejeicao (tipo) {
      if (tipo === 'excluir') {
        this.titulo_confirmacao = 'Confirma a exclusão do registro selecionado?'
      } else {
        this.titulo_confirmacao = 'Confirma a rejeição do registro selecionado?'
      }

      this.$bvModal.msgBoxConfirm(this.titulo_confirmacao, {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/' + tipo + '/' + this.usuario.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getUsuario', this.$route.params.id)
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getUsuario', this.$route.params.id)
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    modalConfirmaAprovacao () {
      this.$bvModal.msgBoxConfirm('Confirma a aprovação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/aprovar/' + this.usuario.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getUsuario', this.usuario.id)
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    modalConfirmaSuspensao () {
      this.$bvModal.msgBoxConfirm('Confirma a suspensão do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/suspender/' + this.usuario.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getUsuario', this.usuario.id)
            }
          })
        } else {
          this.modalPreAprovar = true
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    modalConfirmaAtivacao () {
      this.$bvModal.msgBoxConfirm('Confirma a ativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/ativar/' + this.usuario.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getUsuario', this.usuario.id)
            }
          })
        } else {
          this.modalPreAprovar = true
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    navigate () {
      let id = this.$route.params.id
      this.$router.push('/usuario/' + id + '/editar')
    }
  }
}
</script>

<style scoped>
    .action {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuarioVisualizar.vue